import InstructionsDialog from './InstructionsDialog';

export default InstructionsDialog;